import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Error } from '@rpe/registro-personas-empresas-lib';
import { Tecnico } from '../entity-tecnicos/entity-tecnicos.model';

export const entityTecnicosAdapter: EntityAdapter<Tecnico> =
  createEntityAdapter<Tecnico>({
    selectId: (model) => model.id,
    sortComparer: (a: Tecnico, b: Tecnico): number =>
      a.id.toString().localeCompare(b.id.toString())
  });

export interface EntityTecnicosState extends EntityState<Tecnico> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityTecnicosState =
  entityTecnicosAdapter.getInitialState({
    isLoading: false,
    error: null
  });
